const TEXT = {
    COMMON: {
        TITLE: 'Anagram',
    }
}

export default TEXT;